import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { baseUrl, URLs } from 'src/constants/urls';
import Accordion from '../accordion/Accordion';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';
import Search from '../search/search';
import Title from '../title/Title';
import accordionData from './accordionData';
import './NewHelpSupportItems.css'

export interface INewItemsProps {
    history: any;
}

class NewHelpSupportItems extends React.Component<INewItemsProps> {
    public state: any;
    constructor(props: any) {
        super(props);
    }
    public render() {

        const breadcrumbItems = [{ caption: "What's new", url: `${URLs.whatsNew}` }]
        return (
            <Col xs="12">
                <Breadcrumbs items={breadcrumbItems} redirect={this.redirect} />
                <Row>
        <Col xs={{ size: 10, offset: 1 }} className="pt-2">
                <Search />
                <Title title={"What's new in Gem Connect?"} />
                <Row className="tile-container">
            <Col xs="12">
              <div className="topic-content"  >
                  <p>Keep up to date with changes and improvements we’ve made to Gem Connect.</p>
                  <hr className="newhelphr"/>
                  <p className="newhelppara"><strong>Availability of interest posting details</strong></p>
                  <p>We’ve added a new attribute called ‘interest source’ to some reports to show where interest has been earned (the account number and sort code), if the interest posting relates to interest redirection from another account.&nbsp;&nbsp;The new field will be available for selection in ‘Manage columns’ when viewing or exporting in CSV or CSV consolidated format, the Transaction detail, and the Balance and transaction detail reports. You’ll also see it when viewing ‘Details’ for a specific transaction, when running the Transaction history report.</p>

                  <p className="newhelppara"><strong>Addition of page breaks to PDF exports of Transaction detail report</strong></p>
                  <p>We’ve further enhanced our Transaction detail report by adding page breaks, when it’s exported in PDF format.&nbsp;&nbsp;You’ll now see a page break separating each account's transaction history when exporting the Transaction detail reports in PDF format. </p>

                  <p className="newhelppara"><strong>Amendment to our Profile entitlement report</strong></p>
                  <p>We’ve listened to your feedback, and we’ve improved our Profile entitlement report, it’ll now display the name of the user associated with the profile, rather than their user ID.</p>

                <div>
                    <div className="newhelpcont" >
                    < h3 >Archive</h3>
                    </div>
                    <div>
                        <Row>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>March 2025</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData5}/>
                        </Col>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>December 2024</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData4}/>
                        </Col>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>June 2024</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData3}/>
                        </Col>
                        <Col xs={{size: 2, offset: 0}}>
                        <p>March 2024</p>
                        </Col>
                        <Col xs={{size: 10, offset: 0}}>
                        <Accordion accordianData={accordionData.accordionData1}/>
                        </Col>
                        </Row>
                    </div>
                </div>
                </div>
                
            </Col>
          </Row>
                </Col>
                </Row>
            </Col>
        );
    }
    private redirect = (url = baseUrl) => {
        this.props.history.push(url)
    }
};

export default NewHelpSupportItems;




// WEBPACK FOOTER //
// ./src/components/newHelpSupportItems/NewHelpSupportItems.tsx